<template>
  <b-modal
    v-model="showModal"
    :title="`Editar ${levelLabel}`"
    size="xl"
    scrollable
    no-close-on-esc
    ok-title="Salvar"
    cancel-title="Cancelar"
    @ok.prevent="submit"
    @hidden="onHidden"
  >
    <div v-if="loading" class="p-4 text-center text-muted">Carregando...</div>
    <b-tabs v-else pills card vertical class="edit-menu-sidebar">
      <b-tab title="Dados Básicos" active>
        <DadosBasicos />
      </b-tab>
      <b-tab title="ODS">
        <Ods />
      </b-tab>
      <b-tab title="Indicadores">
        <Indicadores />
      </b-tab>
      <b-tab title="Metas">
        <Metas />
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import DadosBasicos from "@/modules/objectives/components/Form/DadosBasicos";
import Ods from "@/modules/objectives/components/Form/Ods";
import Indicadores from "@/modules/objectives/components/Form/Indicadores";
import Metas from "@/modules/objectives/components/Form/Metas";
import services from "@/http";
import { mapState, mapActions } from "vuex";

export default {
  components: { DadosBasicos, Ods, Indicadores, Metas },
  props: {
    strategicPlanId: { type: [Number, String], required: true },
  },
  data: () => ({
    showModal: false,
    loading: false,
    nodeId: null,
    depth: 0,
  }),
  computed: {
    ...mapState("strategic_plans", ["strategic_plan"]),
    ...mapState("objectives", ["objective"]),
    planLevels() {
      return this.strategic_plan?.config?.plan_structure?.levels || [];
    },
    levelLabel() {
      const defaults = ["Nível 1", "Nível 2", "Nível 3", "Nível 4", "Nível 5"];
      return this.planLevels[this.depth] || defaults[this.depth] || `Nível ${this.depth + 1}`;
    },
  },
  methods: {
    ...mapActions("objectives", ["ActionSetOjective", "ActionGetOds"]),
    async show(node, depth = 0) {
      this.nodeId = node.id;
      this.depth = depth;
      this.loading = true;
      this.showModal = true;

      try {
        const { data } = await services.strategic_plans.plan_structure_detail({ id: node.id });
        const odsIds = (data.ods || []).map((o) => (typeof o === "object" ? o.id : o));
        this.ActionSetOjective({
          id: data.id,
          name: data.name || "",
          description: data.description || "",
          indicators: data.indicators || [],
          measures: data.measures || [],
          ods: odsIds,
          _is_plan_structure: true,
        });
        this.ActionGetOds();
      } finally {
        this.loading = false;
      }
    },
    async submit() {
      if (!this.objective || !this.objective.name || !this.objective.name.trim()) {
        this.$notifications.addNotification({
          message: "O nome é obrigatório.",
          type: "danger",
        });
        return;
      }

      try {
        await services.strategic_plans.plan_structure_update_full(
          { id: this.nodeId },
          {
            name: this.objective.name,
            description: this.objective.description || null,
            ods: this.objective.ods || [],
            indicators: this.objective.indicators || [],
          }
        );
        this.$notifications.addNotification({
          message: `${this.levelLabel} atualizado com sucesso!`,
          type: "success",
        });
        this.showModal = false;
        this.$emit("saved");
      } catch (error) {
        this.$notifications.addNotification({
          message: `Erro ao salvar ${this.levelLabel.toLowerCase()}.`,
          type: "danger",
        });
      }
    },
    onHidden() {
      this.ActionSetOjective(null);
    },
  },
};
</script>
